import { Outlet, NavLink, Navigate, useLocation, useNavigate } from "react-router-dom";
import { CreditCard02, Settings01 } from "@untitledui/icons";
import { Select } from "@/components/base/select/select";
import { cx } from "@/utils/cx";

const navLinkClass = ({ isActive }: { isActive: boolean }) =>
  cx(
    "flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-medium transition-colors",
    isActive
      ? "bg-bg-active text-text-primary"
      : "text-text-secondary hover:bg-bg-secondary_hover hover:text-text-primary"
  );

const SUB_ROUTES = [
  { id: "/settings/general", label: "General", icon: Settings01 },
  { id: "/settings/billing", label: "Billing", icon: CreditCard02 },
];

export default function SettingsLayout() {
  const location = useLocation();
  const navigate = useNavigate();

  if (location.pathname === "/settings") {
    return <Navigate to="/settings/general" replace />;
  }

  return (
    <div className="flex flex-col h-full">
      {/* Sticky header */}
      <header className="sticky top-0 z-10 bg-bg-primary px-4 py-4 sm:px-6 sm:py-5 lg:px-8 lg:py-6 border-b border-border-secondary">
        <div className="mx-auto max-w-7xl">
          <h1 className="text-lg font-semibold text-text-primary sm:text-display-xs">Settings</h1>
        </div>
      </header>

      <div className="flex-1 min-h-0 px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-7xl flex flex-col md:flex-row h-full gap-6">
          {/* Mobile dropdown */}
          <div className="md:hidden pt-4">
            <Select
              size="sm"
              items={SUB_ROUTES}
              selectedKey={location.pathname}
              onSelectionChange={(key) => navigate(key as string)}
              aria-label="Settings section"
            >
              {(item) => (
                <Select.Item key={item.id} id={item.id} label={item.label} icon={item.icon} />
              )}
            </Select>
          </div>

          {/* Desktop sticky sidebar */}
          <nav className="hidden md:block w-56 shrink-0 sticky top-[73px] self-start space-y-1 pt-6">
            <NavLink to="/settings/general" className={navLinkClass}>
              <Settings01 className="size-5 shrink-0" />
              General
            </NavLink>
            <NavLink to="/settings/billing" className={navLinkClass}>
              <CreditCard02 className="size-5 shrink-0" />
              Billing
            </NavLink>
          </nav>

          {/* Scrollable content */}
          <div className="flex-1 min-w-0 py-6 overflow-auto scrollbar-hide">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}
